import * as _ from 'lodash';

export const unifiedAjax = 'pcommon/unifiedAjax';

export const regionList = 'pcommon/regionList';
export const RegionInfos = 'pcommon/RegionInfos';

export const QueryProductGroups = 'pcommon/QueryProductGroups';

export const Getlines = 'pcommon/Getlines';

export const CalcEipPrice = 'pcommon/CalcEipPrice';

export const DescribeBandWidthShares = 'pcommon/DescribeBandWidthShares';

export const OSImageList = 'pcommon/OSImageList';
export const ImageList = 'pcommon/ImageList';

export const DedicatedList = 'pcommon/DedicatedList';
export const projList = 'pcommon/projList';
export const getDedicatedCluster = 'pcommon/getDedicatedCluster';
export const snapList = 'pcommon/snapList';
export const snapLessNum = 'pcommon/snapLessNum';
export const getEbsSnap = 'pcommon/getEbsSnap';
export const CalculateKeadProduct = 'pcommon/CalculateKeadProduct';
//--以下为未登录constants--
export const noLoginGetlines = 'pcommon/noLoginGetlines';
export const noLoginQueryProductGroups = 'pcommon/noLoginQueryProductGroups';


import * as productService from '../../services/kec/product'

//--以上为未登录constants--
//全部机型: 新增机型时需要配置此处
//默认排列顺序： 通用型、标准型、IO优化型、计算优化型、容器实例型、标准网络型、基础型、ARM、ARM、GPU计算型、GPU虚拟化型
export const AllKecType = [
    {
        title: 'COMVM', //通用型: 通用型N3、通用型N2、通用型N1
        value: [151, 137, 40]
    }, {
        title: 'SNVM', //标准型: 标准型A6、标准型S6、标准型S4、标准型S3、标准型S1   AMD: 标准型SA1
        value: [652, 595, 348, 498, 152, 298, 198]
    }, {
        title: 'IOVM', //IO优化型: IO优化型I6、IO优化型I4、IO优化型I3、IO优化型I2、IO优化型I2（联网增强）、IO优化型I1、IO优化型I1（联网增强）
        value: [668, 357, 110, 78, 79, 41, 45]
    }, {
        title: 'CALVM', //计算优化型: 计算优化型C7、计算优化型C5、计算优化型C4、计算优化型C3、计算优化型C1、计算优化型C1（联网增强）
        value: [712, 548, 347, 111, 42, 46]
    }, {
        title: 'CONTAINER', //容器实例型: 容器实例型主机
        value: [192]
    }, {
        title: 'XVM', //性能保障型: 专属型NI6、性能保障型X8、性能保障型X7、性能保障型X6、性能保障型X5、性能保障型X2
        value: [731, 729, 687, 547, 508, 138]
    }, {
        title: 'SN3', //标准网络型: 标准网络型SN3
        value: [187]
    }, {
        title: 'BDM', //大数据型: 大数据型D6、大数据型D4
        value: [641, 430]
    }, {
        title: 'EVM', //基础型: 基础型E1
        value: [303]
    }, {
        title: 'ARM', //ARM: ARM计算型AC4、ARM计算型AC2、ARM计算型AC1、ARM计算型FC1
        value: [710, 388, 305, 401]
    },
    {
        title: 'RVM', //内存型：内存型R6
        value: [647]
    },
    {
        title: 'HKEC', //星河：星河云服务器
        value: [656]
    },
    // 产品张溪源的需求，没有wiki只提了ones，需求如下：
    // 将极速云盘型X6E 和 性能保障型X6H 移动到增强型中，并X6S→X6E→X6N→X6H按照顺序排序
    {
        title: 'NPEVM', //增强型：性能增强型X6S、极速云盘型X6E、网络增强型X6N、性能保障型X6H
        value: [650, 628, 651, 627]
    },
    // {
    //     title: 'NPEVM', //增强型：网络增强型X6N
    //     value: [651]
    // },
    // {
    //     title: 'NPEVM', //增强型：性能增强型X6S
    //     value: [650]
    // },
    // {
    //     title: 'AMD', //AMD: 标准型SA1
    //     value: [198]
    // },
    {
        title: 'GPU1', //GPU计算型：GPU通用计算型GN7I、GPU高效计算型（P5V）、推理Ⅱ型(GN6I)、GPU推理I型(GN5I)、GPU通用计算型(P4V)、GPU推理计算型-P3I、GPU推理计算型(P3IN)、GPU通用计算型(P3)、GPU通用计算型(P3L)、GPU图形计算型(G1)
        value: [690, 661, 326, 597, 125, 101, 142, 77, 353, 126]
    }, {
        title: 'GPU2', //GPU虚拟化型: GPU虚拟型（vGN6）、GPU虚拟型(vGN5)
        value: [377, 321]
    }, {
        title: 'SE',
        value: [162006]
    }
]
export let allKecTypeDefaultSortCodes = [];
_.forEach(AllKecType, (item:any) => {
    allKecTypeDefaultSortCodes = allKecTypeDefaultSortCodes.concat(item.value);
});

export const allKecTypeDefaultSort = function (typeCode:any) {
    return _.indexOf(allKecTypeDefaultSortCodes, typeCode * 1) !== -1;
}

//通用型主机 注：不支持本地数据盘
export const isCommonModelType = function (productTypeId:number) {
    //通用型N1、通用型N2、通用型N3、标准型SA1、计算优化型C4、标准型S4、GPU虚拟型(vGN6)、推理Ⅱ型(GN6I)、IO优化型I4、大数据型D4、ARM计算型FC1、性能保障型X5、计算优化型C5、性能保障型X6、GPU推理I型(GN5I)、标准型S6
    // let commonModelTypeCodes = [40, 137, 151, 198, 347, 348, 377, 326, 357, 430, 401, 508, 548, 547, 597, 595];
    // return _.indexOf(commonModelTypeCodes, typeCode * 1) !== -1;

    return productService.isCommonModelType(productTypeId);

}

//数据盘即支持本地ssd又支持云盘的主机类型
export const is2dataDiskType = function (productTypeId:number) {
    //IO2、IO3、S3、X2、SN3、GPU推理计算型(P3I)、GPU通用计算型(P3)、GPU通用计算型(P4V)、GPU推理计算型(P3IN)、基础型E1、ARM计算型AC1、计算优化型C3、GPU虚拟化(vGN5)、IO优化型I4、ARM计算型AC2
    // let is2dataDiskTypeCodes = [78, 110, 152, 138, 187, 101, 77, 125, 142, 303, 305, 111, 321, 357, 388];
    // return _.indexOf(is2dataDiskTypeCodes, typeCode * 1) !== -1;
    return productService.is2dataDiskType(productTypeId)
}



//系统盘支持调整系统盘大小的主机类型
export const isAdjustSysDiskType = function (productTypeId:number) {
    //通用型N1、IO优化型I1、IO优化型I1（联网增强）、计算优化型C1、计算优化型C1（联网增强）、IO优化型I2、IO优化型I2（联网增强）、性能保障型X2、通用型N2、通用型N3、专属2代、标准型SA1、基础型E1、ARM计算型AC1、推理Ⅱ型(GN6I)、GPU通用计算型(P3L)、标准型S3、IO优化型I3、计算优化型C3、标准网络型SN3、计算优化型C4、标准型S4、GPU虚拟型(vGN6)、IO优化型I4、ARM计算型AC2、GPU推理计算型(P3IN)、GPU虚拟型(vGN5)、GPU通用计算型(P3)、GPU推理计算型-P3I、GPU通用计算型(P4V)、大数据型D4、ARM计算型FC1、性能保障型X5、计算优化型C5、性能保障型X6、标准型S1、GPU推理I型(GN5I)、标准型S6
    // let adjustTypeCodes = [40, 41, 45, 42, 46, 78, 79, 138, 137, 151, 143, 198, 303, 305, 326, 353, 152, 110, 111, 187, 347, 348, 377, 357, 388, 142, 321, 77, 101, 125, 430, 401, 508, 548, 547, 298, 597, 595];
    // return _.indexOf(adjustTypeCodes, typeCode * 1) !== -1;
    return productService.isAdjustSysDiskType(productTypeId);
}

//迁移到services/kec/product
// //GPU类型
// export const isGpuModelType = function (productTypeId:number) {
//     //推理Ⅱ型(GN6I)、GPU通用计算型(P4V)、GPU推理计算型-P3I、GPU推理计算型(P3IN)、GPU通用计算型(P3)、GPU通用计算型(P3L)、GPU图形计算型(G1)、GPU虚拟型（vGN6）、GPU虚拟型(vGN5)、GPU推理I型(GN5I)
//     // let gpuMOdelTypesCodes = [326, 125, 101, 142, 77, 353, 126, 377, 321, 597];
//     // return _.indexOf(gpuMOdelTypesCodes, typeCode * 1) !== -1;
//     return productService.getArchById(productTypeId) === 'gpu';
// }
